import { z } from "zod";
export const ItemSolicitudQrSchema = z.object({
    productoId: z.string(),
    nombre: z.string(),
    cantidad: z.number().int().min(1),
    precioUnitario: z.number().min(0),
    subtotal: z.number().min(0),
    notas: z.string().optional(),
});
export const CrearSolicitudQrSchema = z.object({
    qrToken: z.string().min(1),
    items: z.array(ItemSolicitudQrSchema).min(1, "Debe incluir al menos un producto"),
    notasGenerales: z.string().optional(),
});
export const ProcesarSolicitudQrSchema = z.object({
    accion: z.enum(["ACEPTAR", "RECHAZAR"]),
    motivoRechazo: z.string().optional(),
});
// ------------------------------------------------------------------
// Respuestas (lo que el backend REALMENTE devuelve). z.coerce.number()
// en `subtotal` por lo mismo de siempre: Prisma serializa `Decimal`
// como string (ver PROGRESS.md sección 5b/7).
// ------------------------------------------------------------------
const MontoCoercible = z.coerce.number();
export const SolicitudQrRespuestaSchema = z.object({
    id: z.string(),
    sucursalId: z.string(),
    mesaId: z.string(),
    mesaNumero: z.number(),
    mesaNombre: z.string().nullable().optional(),
    qrToken: z.string(),
    estado: z.enum(["PENDIENTE", "ACEPTADO", "RECHAZADO"]),
    motivoRechazo: z.string().nullable().optional(),
    items: z.array(ItemSolicitudQrSchema),
    subtotal: MontoCoercible,
    creadoEn: z.string(),
});
export const MesaPorQrRespuestaSchema = z.object({
    id: z.string(),
    numero: z.number(),
    nombre: z.string().nullable().optional(),
    sucursalId: z.string(),
    sesionActivaId: z.string().nullable().optional(),
    sucursal: z.object({
        id: z.string(),
        nombre: z.string(),
        direccion: z.string().nullable().optional(),
    }),
});
//# sourceMappingURL=solicitud-qr.schema.js.map